import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { LenderAccountInfo, LenderProductAccountInfo } from '../../../../model/finzy-flex/lender-account.model';
import { Keys, StorageService } from '../../../../service/storage.service';
import { ActivatedRoute } from "@angular/router";
import { ConfirmWithdrawalPopupCompoenent } from '../confirm-withdrawal-popup/confirm-withdrawal-popup.component';
import { cloneDeep } from 'lodash';
import { Router } from "@angular/router";

@Component({
  selector: 'app-initiate-withdrawal-popup',
  templateUrl: './initiate-withdrawal-popup.component.html',
  styleUrls: ['./initiate-withdrawal-popup.component.css']
})
export class InitiateWithdrawalPopupComponent implements OnInit {

  subProducts: Array<any> = [];
  lenderAccountInfo: LenderAccountInfo;
  withdrawalRequestForm: FormGroup;
  withdrawalRequestInProgress: boolean = false;

  constructor(
    activatedRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private router: Router
  ) {
    this.matDialog = matDialog;
    this.withdrawalRequestForm = this.formBuilder.group({
      lenderId: this.storageService.getItem(Keys.LENDER_ID),
      withdrawalRequests: this.formBuilder.array([])
    });
    activatedRoute.data.subscribe((data) => {
      this.lenderAccountInfo = data.lenderAccountInfo.data[0];
    });

    this.lenderAccountInfo.products = this.lenderAccountInfo.products.filter((product: any) => {
      if(product.withdrawBackMoney && product.withdrawBackMoney > 0) {
        return product;
      }
    });

    let products = cloneDeep(this.lenderAccountInfo?.products?.sort((a, b) => {
      let temp1 = String.fromCharCode(parseInt(a?.productCode, 16));
      let temp2 = String.fromCharCode(parseInt(b?.productCode, 16));
      return temp1 < temp2 ? -1 : temp1 > temp2 ? 1 : 0;
    }))
    products?.forEach((lenderProductAccountInfo: LenderProductAccountInfo) => {
      if (lenderProductAccountInfo.withdrawBackMoney > 0)
        this.addWithdrawalRequestForm(lenderProductAccountInfo);
    })
  }

  ngOnInit(): void {
  }

  onMayBeLater() {
    this.router.navigate(['/finzy-flex/dashboard']);
  }

  async onWithdrawMoney() {
    this.withdrawalRequestInProgress = true;
    const matDialogConfig: MatDialogConfig = {
      height: '90%',
      width: '50%',
      panelClass: "withdraw-popup",
      disableClose: true,
      data: { withdrawalRequestForm: this.withdrawalRequestForm, withdrawalRequests: this.withdrawalRequests, getTotalWithdrawalAmount: this.getTotalWithdrawalAmount() }
    };
    this.matDialog.open(ConfirmWithdrawalPopupCompoenent, matDialogConfig).afterClosed().subscribe(response => {
      if (!response) {
        this.withdrawalRequestInProgress = false;
      } else {
        this.withdrawalRequestInProgress = false;
      }
    })
  }

  get withdrawalRequests() {
    return this.withdrawalRequestForm.get('withdrawalRequests') as FormArray;
  }

  addWithdrawalRequestForm(lenderProductAccountInfo: LenderProductAccountInfo) {
    const withdrawalForm = this.formBuilder.group({
      productCode: [lenderProductAccountInfo.productCode],
      withdrawalAmount: ['', [Validators.min(1), Validators.max(this.priciseNumber(lenderProductAccountInfo.withdrawBackMoney))]]
    });
    this.withdrawalRequests.push(withdrawalForm);
  }

  getTotalWithdrawalAmount(): any {
    return this.withdrawalRequestForm.get('withdrawalRequests')
      .value
      .map(val => val.withdrawalAmount)
      .reduce((x: number, y: number) => x + y, 0);
  }

  priciseNumber(number: number) {
    return Math.floor(number * 100) / 100;
  }

  getAmountStylings(value) {
    const amount = this.priciseNumber(value);
    return {
      'color': amount < 0 ? 'red' : '#4db53e',
      'font-weight': 'bold'
    }
  }

  getErrorMessage(event) {
    if (event && event?.value !== null && event?.value !== '' && event?.value < 1) {
      return 'Amount must be greater than or equal to Rs 1'
    }
    else if (event && event?.errors?.max?.actual > event?.errors?.max?.max) {
      return 'Withdraw amount is higher than the withdrawable amount, please change amount'
    }
  }
}
